module.exports = __webpack_public_path__ + "static/media/Engpic2@2x.ff45741d.png";